'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_ImportRecipesPage$Props(preload) {
  this.LV = false;
  this.LV = preload;
}
export { $c_Lmealorama_pages_ImportRecipesPage$Props as $c_Lmealorama_pages_ImportRecipesPage$Props };
$p = $c_Lmealorama_pages_ImportRecipesPage$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_ImportRecipesPage$Props;
/** @constructor */
function $h_Lmealorama_pages_ImportRecipesPage$Props() {
}
export { $h_Lmealorama_pages_ImportRecipesPage$Props as $h_Lmealorama_pages_ImportRecipesPage$Props };
$h_Lmealorama_pages_ImportRecipesPage$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 77388112);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.LV ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 1);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_pages_ImportRecipesPage$Props) && (this.LV === x$0.LV)));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.LV;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_pages_ImportRecipesPage$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kr)));
}
export { $isArrayOf_Lmealorama_pages_ImportRecipesPage$Props as $isArrayOf_Lmealorama_pages_ImportRecipesPage$Props };
var $d_Lmealorama_pages_ImportRecipesPage$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_ImportRecipesPage$Props, "mealorama.pages.ImportRecipesPage$Props", ({
  kr: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_ImportRecipesPage$Props as $d_Lmealorama_pages_ImportRecipesPage$Props };
//# sourceMappingURL=mealorama.pages.-Import-Recipes-Page$-Props.js.map
